import { useState, useEffect } from 'react';
import { fetchSelectOptions } from '@/components/formBuilder/helpers/formHelpers';
import { KAutoComplete } from '@/ui-library/components/organisms/KFields/KAutoComplete';
import { CustomValueContainer } from '@/components/ats/EmailTemplates/EmailTemplates';

export const ChooseTemplate = ({
  selectOnChange = () => {},
  channel = 'email',
  category = 'candidate_job_stage_action_notice',
  setDefault = false,
  styleVersion = 'v1',
}) => {
  const [templates, setTemplates] = useState([]);
  const [, setIsLoading] = useState();
  const [isDefaultSet, setDefaultDone] = useState(false);
  const [, setSelected] = useState();

  const buildEndPoint = () => {
    // If category is a string, format it as expected
    if (typeof category === 'string') {
      return `/ats_comm_templates?filter_by[channel]=${channel}&filter_by[category][]=${category}&items=200&filter_by[name]=`;
    }

    // If category is an array, join its elements with '&filter_by[category][]='
    if (Array.isArray(category)) {
      const categories = category
        .map((cat) => `&filter_by[category][]=${cat}`)
        .join('');
      return `/ats_comm_templates?filter_by[channel]=${channel}${categories}&items=200&filter_by[name]=`;
    }

    // Handle case if category is neither a string nor an array (optional)
    throw new Error(
      'Invalid category type: must be a string or an array of strings.'
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const apiConfig = {
          endPoint: buildEndPoint(),
        };
        const list = await fetchSelectOptions(apiConfig);
        await setTemplates(list);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!setDefault || isDefaultSet || templates?.length === 0) return;
    selectOnChange(templates?.[0]);
    setSelected({
      label: templates?.[0]?.name,
      value: templates?.[0]?.id,
      ...templates?.[0],
    });
    setDefaultDone(true);
  }, [templates, setDefault]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <KAutoComplete
      item={{
        name: 'emailTemplates',
        label: 'Email Templates',
        type: 'autoComplete',
        useInput: true,
        isRequired: true,
        isMulti: false,
        placeholder: `Select a template`,
        labelKey: 'name',
        valueKey: 'id',
        customOnChange: selectOnChange,
        styleVersion: styleVersion,
        options: templates,
        updateEndpointOnChange: true,
        fetchConfig: {
          method: 'get',
          endPoint: buildEndPoint(),
          processResponse: (res) => {
            const options = res?.data?.map((item) => ({
              label: item?.name,
              value: item?.id,
              ...item,
            }));

            return options;
          },
        },
        components: {
          ValueContainer: CustomValueContainer,
        },
      }}
    />
  );
};
